<app-content-modal [buttons]="buttons">
  <h1>{{ 'PROFILE.EDIT_AVATAR.EDIT_PROFILE_IMAGE' | translate }}</h1>
  <app-avatar size="big" [userInfo]="user"></app-avatar>
</app-content-modal>
